import { Button, Grid, Typography, TextField, Box, Hidden
    , FormControl, InputLabel, Select, IconButton } from "@mui/material";
import { Search as IconSearch, IndeterminateCheckBox as IconIndeterminateCheckBox
    , CheckBox as IconCheckBox, PersonAdd as IconPersonAdd } from "@mui/icons-material";
import * as terapiaService from "../../services/terapiaService";
import * as filialService from "../../services/filialService";
import * as catalogoService from "../../services/catalogoService";
import { useDispatch, useSelector } from 'react-redux';
import { useEffect, useState } from "react";
import moment from "moment";
import { Link, useNavigate } from "react-router-dom";
import { setValue, setFiliales, setListEstados } from '../../redux/therapySearchSlice';
import { setPersonList } from "../../redux/personSlice";
import DialogYesNo from '../../components/DialogYesNo';
import DataGridBase from "../../components/common/DataGridBase"
import { useMantenimiento } from "../../hooks/useMantenimiento";

const Index = () => {
    const { isReadOnly, idFilial, perfilCargado } = useMantenimiento("terapia");
    const filters = useSelector((state) => state.therapySearch.filters);
    const listFiliales = useSelector((state) => state.therapySearch.listFiliales);
    const listEstados = useSelector((state) => state.therapySearch.listEstados);

    const [openDialogAnnulActive, setOpenDialogAnnulActive] = useState(false)
    const openCloseDialogAnnulActive = () => { setOpenDialogAnnulActive(!openDialogAnnulActive); }
    const [selectId, setSelectId] = useState(null);
    const [selectState, setSelectState] = useState(null);

    const [cargando, setCargando] = useState(true);
    const [results, setResults] = useState([]);
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const fetchResults = async (filtros = filters) => {
        setCargando(true);

        await terapiaService.getsTerapiaResumenView(filtros)
            .then((data) => {
                setResults(data);
                setCargando(false);
            })
            .catch((err) => {
                setCargando(false);
                console.log("Err: ", err)
            });
    }
    const fetchFiliales = async () => {
        await filialService.getFilialesList()
            .then((data) => {
                // Si el usuario tiene filial asignada, su filtro solo ofrece esa.
                dispatch(setFiliales(filialService.soloFilialDelUsuario(data, idFilial)));
            })
            .catch((err) => {
                setCargando(false);
                console.log("Err: ", err)
            });
    }
    const fetchEstados = async () => {
        await catalogoService.getCatalogosByPadre(1)
            .then((data) => {
                dispatch(setListEstados(data));
                dispatch(setValue({name: "idEstado", value: 2}))
            })
            .catch((err) => {
                setCargando(false);
                console.log("Err: ", err)
            });
    }
    const annul = async () => {
        await terapiaService.annulTerapia(selectId)
            .catch((err) => {
                setCargando(false);
                console.log("Err: ", err);
            });
            fetchResults();
    }
    const active = async () => {
        await terapiaService.activeTerapia(selectId)
            .catch((err) => {
                setCargando(false);
                console.log("Err: ", err);
            });
            fetchResults();
    }

    useEffect(() => {
        fetchEstados();
    }, []);

    // El filtro de filial se arma cuando llega el perfil del usuario: si se
    // armara antes, se verian todas las sedes. Con una filial asignada el
    // filtro queda fijo en esa y el listado sale ya acotado.
    useEffect(() => {
        if (!perfilCargado) return;

        fetchFiliales();

        if (idFilial > 0) {
            dispatch(setValue({ name: "idFilial", value: idFilial }));
            fetchResults({ ...filters, idFilial });
        }
        else {
            fetchResults();
        }
    }, [perfilCargado, idFilial]);

    const columns = [
        { field: 'idTerapia', headerName: 'ID', width: 50, minWidth: 45, sortable: true, headerAlign: 'center', align: 'center',
            renderCell: (p) => <span style={{ fontSize: '0.75rem', color: '#666', fontFamily: 'monospace' }}>{p.value != null ? p.value : p.row.id}</span> },
        // { field: 'id', headerName: 'ID', width: 50, sortable: false, headerAlign: 'center', align: 'center' },
        // { field: 'codigoServicio', headerName: 'Servicio', width: 50, sortable: false, headerAlign: 'center', align: 'center' },
        { field: 'filial', headerName: 'Filial', width: 70, sortable: false, headerAlign: 'center', align: 'center' },
        { field: 'participante', headerName: 'Participante', width: 175, sortable: true, headerAlign: 'center'
            , renderCell: (cellValues) => {
                return <Link to={'/therapy/edit/' + cellValues.row.idTerapia} style={{ color: 'inherit' }}>{cellValues.row.participante}</Link>;
            }
        },
        { field: 'terapeuta', headerName: 'Terapeuta', width: 175, sortable: false, headerAlign: 'center' },
        { field: 'tipo', headerName: 'Tipo', width: 50, sortable: false, headerAlign: 'center', align: 'center' },
        { field: 'horario', headerName: 'Horario', width: 180, sortable: false, headerAlign: 'center' },
        { field: 'codigoTarifa', headerName: 'Tarifa', width: 80, sortable: false, headerAlign: 'center', align: 'center' },
        { field: 'fechaInicio', headerName: 'Inicio', width: 105, sortable: false, headerAlign: 'center', align: 'center'
            , renderCell: (cellValues) => cellValues.row.fechaInicio ? moment(cellValues.row.fechaInicio).format('DD/MM/YYYY') : '' },
        { field: 'estado', headerName: 'Estado', width: 75, sortable: false, headerAlign: 'center', align: 'center' },
        // La columna Sesiones no se muestra, pero el dato sigue llegando porque
        // el boton de anular depende de el: una terapia con sesiones activas no
        // se anula.
        { field: 'anular', headerName: '', width: 80, sortable: false, headerAlign: 'center', align: 'center'
            , renderCell: (cellValues) => {
                // Una terapia con sesiones activas no se anula: las sesiones
                // son el registro del trabajo hecho.
                const conSesiones = cellValues.row.sesionesActivas > 0;
                return <IconButton aria-label="anular" size='small' style={{height: 10}} align={"center"}
                    disabled={isReadOnly || conSesiones} onClick={() => {
                        setSelectId(cellValues.row.idTerapia);
                        setSelectState(cellValues.row.estado);
                        setOpenDialogAnnulActive(true);
                    }}>
                    { cellValues.row.estado == "A" ? <IconIndeterminateCheckBox /> : <IconCheckBox /> }
                </IconButton>;
            }
        },
    ];

    return (
        <div>
            <Grid container>
                <Grid item>
                    <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
                        Terapias
                    </Typography>
                </Grid>
                <Grid container spacing={1} padding={"12px 0px 0px 0px"}>
                    <Grid item xs={12} sm={12}>
                        <Grid container item xs={12} sm={12} spacing={1}>
                            <Grid item xs={6} sm={2}>
                                <FormControl fullWidth>
                                    <InputLabel htmlFor="input-filial" shrink>Filial</InputLabel>
                                    <Select
                                        native
                                        label="Filial"
                                        value={filters.idFilial}
                                        disabled={idFilial > 0}
                                        onChange={(event) => {
                                            dispatch(setValue({name: "idFilial", value: event.target.value}))
                                        }}
                                        onKeyDown={(event) => {
                                            if (event.key === "Enter") {
                                                event.preventDefault();
                                                fetchResults();
                                            }
                                        }}
                                        inputProps={{
                                            name: 'idFilial',
                                            id: 'input-filial',
                                        }}
                                        size="small"
                                    >
                                        {idFilial <= 0 && <option key={0} value={0}>{"(Todos)"}</option>}
                                        {listFiliales.map((row) => (
                                            <option key={row.id} value={row.id}>{row.descripcion}</option>
                                        ))}
                                    </Select>
                                </FormControl>
                            </Grid>
                            <Grid item xs={8} sm={3}>
                                <TextField
                                    name="member"
                                    label="Participante"
                                    value={filters.member}
                                    fullWidth
                                    onChange={(event) => {
                                        dispatch(setValue({name: "member", value: event.target.value}))
                                    }}
                                    onKeyDown={(event) => {
                                        if (event.key === "Enter") {
                                            event.preventDefault();
                                            fetchResults();
                                        }
                                    }}
                                    size="small"
                                />
                            </Grid>
                            <Grid item xs={8} sm={3}>
                                <TextField
                                    name="therapist"
                                    label="Terapeuta"
                                    value={filters.therapist}
                                    fullWidth
                                    onChange={(event) => {
                                        dispatch(setValue({name: "therapist", value: event.target.value}))
                                    }}
                                    onKeyDown={(event) => {
                                        if (event.key === "Enter") {
                                            event.preventDefault();
                                            fetchResults();
                                        }
                                    }}
                                    size="small"
                                />
                            </Grid>
                            <Grid item xs={6} sm={2}>
                                <FormControl fullWidth>
                                    <InputLabel htmlFor="input-estado" shrink>Estado</InputLabel>
                                    <Select
                                        native
                                        label="Estado"
                                        value={filters.idEstado}
                                        onChange={(event) => {
                                            dispatch(setValue({name: "idEstado", value: event.target.value}))
                                        }}
                                        onKeyDown={(event) => {
                                            if (event.key === "Enter") {
                                                event.preventDefault();
                                                fetchResults();
                                            }
                                        }}
                                        inputProps={{
                                            name: 'idEstado',
                                            id: 'input-estado',
                                        }}
                                        size="small"
                                    >
                                        <option key={0} value={0}>{"(Todos)"}</option>
                                        {listEstados.map((row) => (
                                            <option key={row.id} value={row.id}>{row.descripcion}</option>
                                        ))}
                                    </Select>
                                </FormControl>
                            </Grid>
                            <Grid item xs={2} sm={2} display={"flex"} alignItems={"center"}>
                                <Button variant="outlined" fullWidth size="medium" onClick={() => {
                                    fetchResults();
                                }}>
                                    {<Hidden smDown></Hidden>}
                                    <IconSearch />
                                </Button>
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid item>
                        <Box sx={{ display: 'grid', gridTemplateColumns: '1fr' }}>
                            <DataGridBase
                                rows={results}
                                columns={columns}
                                loading={cargando}
                                disabled={isReadOnly}
                                // onNewClick={() => navigate(`/therapy/edit/0`)}
                                toolbarButtons={[
                                    {
                                        text: "Nuevo",
                                        icon: <IconPersonAdd />,
                                        disabled: isReadOnly,
                                        onClick: () => navigate("/therapy/edit/0")
                                    }
                                ]}
                            />
                        </Box>
                    </Grid>
                    <DialogYesNo open={openDialogAnnulActive} openClose={openCloseDialogAnnulActive} setYes={ selectState == "A" ? annul : active} 
                        setNo={() => { return }}
                        titulo={(selectState == "A" ? "Anular" : "Activar") + " Terapia"}
                        texto={"Esta seguro de " + (selectState == "A" ? "anular" : "activar") + " la terapia?"} >
                    </DialogYesNo>
                </Grid>
            </Grid>
        </div>
    )
}
export default Index
